import React, { useEffect, useState } from "react";
import { Breadcrumb, Table, Tag } from "antd";
import moment from "moment";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";
import "./monnify.css";

const MonnifyTransactions = () => {
  const [isloading, setIsLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);

  const renderEntityDetails = (entity, secondaryLabel) => {
    if (!entity) return "-";

    return (
      <div className="entity-details">
        <div className="entity-name">{entity.name || "-"}</div>
        <div className="entity-meta">{entity.email || "-"}</div>
        {secondaryLabel && (
          <div className="entity-meta">{entity[secondaryLabel] || "-"}</div>
        )}
      </div>
    );
  };

  const fetchTransactions = () => {
    setIsLoading(true);
    callApi(
      "GET",
      `${routes.getAdminMonnifyTransactions}?type=all&page=1&limit=50`,
      null,
      setIsLoading,
      (res) => {
        console.log("res", res);
        setTransactions(res?.data?.transactions || res?.data || []);
      },
      (err) => {
        console.error("error fetching monnify transactions", err);
      },
    );
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const columns = [
    { title: "Reference", dataIndex: "reference", key: "reference" },
    { title: "Type", dataIndex: "type", key: "type" },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      render: (customer) => renderEntityDetails(customer),
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      render: (vendor) => renderEntityDetails(vendor, "storeName"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag>{status || "-"}</Tag>,
    },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => moment(date).format("DD MMM YYYY HH:mm"),
    },
  ];

  return (
    <div className="page-content">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Monnify Transactions</Breadcrumb.Item>
      </Breadcrumb>
      <div className="page-title">Monnify</div>
      <Table
        columns={columns}
        dataSource={transactions}
        rowKey={(record) => record.reference || record._id}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default MonnifyTransactions;
